export default function SuccessPanel({ userIdInputId, userId, iconUrl, message, loginUrl, loginButtonLabel, resetLabel, onReset, hideLoginButton = false }) {
  return (
    <div className="success-panel w-full mb-6">
      <div className="success-header flex items-center gap-2 mb-6">
        <img src={iconUrl} alt="Success" width={24} height={24} />
        <p className="keduall-typography heading-h6-normal-400 m-0">{message}</p>
      </div>
      <div className="mb-4">
        <input
          id={userIdInputId}
          type="text"
          readOnly
          className="keduall-form form-input-default-filled-large w-full keduall-typography text-16-normal-400"
          value={userId}
        />
      </div>
      <div className="flex gap-2 justify-center">
        {!hideLoginButton && (
          <a
            href={loginUrl}
            className="keduall-buttons button-outlined-default-normal-secondary flex-1 text-center keduall-typography heading-h6-semibold-600"
          >
            {loginButtonLabel}
          </a>
        )}
        <button
          onClick={onReset}
          className="keduall-buttons button-filled-default-large-primary flex-1  keduall-typography heading-h6-semibold-600 text-white-txt"
        >
          {resetLabel}
        </button>
      </div>
    </div>
  );
}
